export default class Constants{
    static ContestIsNotAvailableMessage = "Contest not available";
    static ContestCompleteYourProfileMessage = "Before participating in a contest, please complete your profile";
    /** Shown in the add-talent wizard after join; unroll is hidden there on purpose. */
    static ContestJoinedWaitNextStepsMessage = "Congratulations! You have successfully joined. Please wait for instructions for the next step.";
}